import React, { useCallback, useEffect, useState } from "react";
import { ClaimLine } from "../../../../../../../../../@types/EOBDetails.types";
import { dollarize } from "../../../../../../../../../utils/commonFunctions/dollar";
import { dateTimeZoneConverter } from "../../../../../../../../../utils/commonFunctions/date";
import { Grid } from "@material-ui/core";
// import { ClaimLine, ExplanationOfBenefitsGridPrintProps } from "../../../../../../types/components/EOB.types";
// import { dollarize } from "../../../../../../utils/commonFunctions/dollarize";
// import { dateTimeZoneConverter } from "../../../../../../utils/commonFunctions/date";

const columns = [
	"Type of Service",
	"Service From",
	"Service Thru",
	"Total Charge",
	"Discount /Penalty",
	"Eligible Expense",
	"Not Covered",
	"Rmk Cd",
	"Deductible Applied",
	"Paid At %",
	"Benefits Paid"
];

const dollarizeColumns = [
	"Total Charge",
	"Discount /Penalty",
	"Eligible Expense",
	"Not Covered",
	"Deductible Applied",
	"Paid At %",
	"Benefits Paid"
];

const ExplanationOfBenefitsGridPrint = ({ claimLinesProps }: { claimLinesProps: any }) => {
	const [claimLines, setClaimLines] = useState<ClaimLine[]>([]);
	const [claimLineAggregation, setClaimLineAggregation] = useState<any>(null);

	const getClaimLineAggregation = useCallback(() => {
		let not_covered: number | any = 0,
			discount: number | string = 0,
			total_charge: number | string = 0,
			eligible_expense: number | string = 0,
			deductible_applied: number | string = 0,
			benefits_paid: number | string = 0;

		claimLinesProps.forEach((claimLine: any) => {
			const { CHGAMT, EERSP, DEDAMT, COPMT, COINAMT, LNDISCAMT, ADJCVRD, PLNRESP } = claimLine;

			const notCovered: number = EERSP - DEDAMT - COPMT - COINAMT;

			if (notCovered) not_covered = not_covered + notCovered;
			if (LNDISCAMT) discount = discount + LNDISCAMT;
			if (CHGAMT) total_charge = total_charge + CHGAMT;
			if (ADJCVRD) eligible_expense = eligible_expense + ADJCVRD;
			if (DEDAMT) deductible_applied = deductible_applied + DEDAMT;
			if (COINAMT) benefits_paid = benefits_paid + PLNRESP;
		});
		if (total_charge) total_charge = dollarize(Number(total_charge));
		if (discount) discount = dollarize(Number(discount));
		if (eligible_expense) eligible_expense = dollarize(Number(eligible_expense));
		if (not_covered) not_covered = dollarize(Number(not_covered));
		if (deductible_applied) deductible_applied = dollarize(Number(deductible_applied));
		if (benefits_paid) benefits_paid = dollarize(Number(benefits_paid));

		setClaimLineAggregation(
			Object.assign(
				{},
				{
					type_of_service: "TOTALS",
					service_from: "",
					service_thru: "",
					CHGAMT: total_charge,
					LNDISCAMT: discount,
					ADJCVRD: eligible_expense,
					not_covered,
					expl_codes: "",
					DEDAMT: deductible_applied,
					paid_at: "",
					PLNRESP: benefits_paid
				}
			)
		);
	}, [claimLinesProps]);

	useEffect(() => {
		getClaimLineAggregation();
		const _claimLines: ClaimLine[] = [];
		claimLinesProps.forEach((claimLine: any) => {
			const {
				TOS,
				INCFRMDT,
				INCTODT,
				EXPLCD01,
				EXPLCD02,
				EXPLCD03,
				CHGAMT,
				EERSP,
				DEDAMT,
				COPMT,
				COINAMT,
				LNDISCAMT,
				ADJCVRD,
				PERC,
				PLNRESP
			} = claimLine;
			let remarkCode = "";
			if (EXPLCD01) remarkCode = remarkCode + EXPLCD01;
			if (EXPLCD02) remarkCode = remarkCode + ", " + EXPLCD02;
			if (EXPLCD03) remarkCode = remarkCode + ", " + EXPLCD03;
			const notCovered = EERSP - DEDAMT - COPMT - COINAMT;
			// console.log("notCovered", notCovered);
			_claimLines.push({
				"Type of Service": TOS,
				"Service From": dateTimeZoneConverter(INCFRMDT) as string,
				"Service Thru": dateTimeZoneConverter(INCTODT) as string,
				"Total Charge": CHGAMT ? CHGAMT : 0,
				"Discount /Penalty": LNDISCAMT ? LNDISCAMT : 0,
				"Eligible Expense": ADJCVRD ? ADJCVRD : 0,
				"Not Covered": notCovered ? notCovered : 0,
				"Rmk Cd": remarkCode,
				"Deductible Applied": DEDAMT ? DEDAMT : 0,
				"Paid At %": PERC ? PERC : 0,
				"Benefits Paid": PLNRESP ? PLNRESP : 0
			});
		});
		setClaimLines(Object.assign([], _claimLines));
	}, [claimLinesProps, getClaimLineAggregation]);

	if (claimLineAggregation === null) return <></>;

	return (
		<div className="claim-details-pdf">
			<Grid container justifyContent="center" className="column-header-row">
				{columns.map((column, index) => {
					return (
						<Grid
							item
							xl={index === 8 ? 2 : 1}
							lg={index === 8 ? 2 : 1}
							key={index}
							className={index === columns.length - 1 ? "" : "column-header-container"}
							style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
						>
							<div style={{ display: "inline-flex" }}>
								<div className="column-header">{column}</div>
							</div>
						</Grid>
					);
				})}
			</Grid>
			{claimLines.map((row, index) => {
				const items = { ...row };
				return (
					<Grid container justifyContent="center" key={index} className="column-item-row">
						{Object.entries(items).map(([key, value], index) => {
							return (
								<Grid
									xl={index === 8 ? 2 : 1}
									lg={index === 8 ? 2 : 1}
									key={index}
									className={
										index === Object.entries(items).length - 1 ? "" : "column-item-container"
									}
									style={{
										flex: 1,
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										height: "20px"
									}}
								>
									<div style={{ display: "inline-flex" }}>
										<div className="column-item">
											{dollarizeColumns.includes(key) ? dollarize(value as number) : value}
										</div>
									</div>
								</Grid>
							);
						})}
					</Grid>
				);
			})}
			<Grid container justifyContent="center" className="column-item-row">
				{Object.entries(claimLineAggregation).map(([key, value], index) => {
					return (
						<Grid
							xl={index === 8 ? 2 : 1}
							lg={index === 8 ? 2 : 1}
							key={index}
							className={
								index === Object.entries(claimLineAggregation).length - 1 ? "" : "column-item-container"
							}
							style={{
								flex: 1,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								height: "20px"
							}}
						>
							<div style={{ display: "inline-flex" }}>
								<div className="column-item">{value as any}</div>
							</div>
						</Grid>
					);
				})}
			</Grid>
		</div>
	);
};

export default ExplanationOfBenefitsGridPrint;
